import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Tabs,
  TabList,
  Tab,
  DragTab,
  PanelList,
  Panel,
  ExtraButton,
} from "react-tabtab";
import * as customStyle from "react-tabtab/lib/themes/material-design";
import BasicSettings from "./settings/BasicSettings";
import UsersSettings from "./settings/UsersSettings";
import ThemeSettings from "./settings/ThemeSettings";
import CertificateSettings from "./settings/CertificateSettings";
import DomainSettings from "./settings/DomainSettings";
import SubscriptionSettings from "./settings/SubscriptionSettings";
import ConferencesSetting from "./ConferencesSetting";

export default class Settings extends Component {
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> / <b>Settings</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center"></div>
            </div>
          </div>

          <div>
            <Tabs customStyle={customStyle}>
              <TabList>
                <Tab>
                  <i class="fas fa-sliders-h"></i> Basic settings
                </Tab>
                {/* <Tab>
                  <i class="fas fa-users"></i> Users
                </Tab>
                <Tab>
                  <i class="fas fa-palette"></i> Themes
                </Tab> */}
                <Tab>
                  <i class="fas fa-certificate"></i> Certifications
                </Tab>
                {/* <Tab>
                  <i class="fas fa-gamepad"></i> Conferences
                </Tab> */}
                {/*   <Tab>
                    <i class="fas fa-shopping-cart"></i> E-commerce
                  </Tab> */}
                {/* <Tab>
                  <i class="fas fa-globe"></i> Domain
                </Tab>
                <Tab>
                  <i class="fas fa-hand-point-up"></i> Subscription
                </Tab> */}
              </TabList>
              <PanelList>
                <Panel>
                  <BasicSettings />
                </Panel>
                {/* <Panel>
                  <UsersSettings />
                </Panel>
                <Panel>
                  <ThemeSettings />
                </Panel> */}
                <Panel>
                  <CertificateSettings />
                </Panel>
                {/* <Panel>
                  <ConferencesSetting />
                </Panel> */}
                {/* <Panel>Gamification</Panel>
                  <Panel>E-commerce</Panel> */}
                {/* <Panel>
                  <DomainSettings />
                </Panel>
                <Panel>
                  <SubscriptionSettings />
                </Panel> */}
              </PanelList>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
